import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { ItemGrid } from '../../models/item';
import { modalComponent } from '../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { Chofer } from '../../models/chofer';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'chofer-consultar',
    styleUrls: [], 
    templateUrl: 'choferes-consultar.component.html',
    providers: [generalService]
})

export class ChoferConsultarComponent implements OnInit{

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: DataSourceGrid | null;
    displayedColumns = ['acciones', 
    //'DRIVER_ID',
    'NAME','DESCRIPTION','LICENSE_NUMBER','RFC','CP',
    //'CITY_ID',
    'City_NAME',
    //'SUBURB','STREET',
    //'OUTDOOR_NUMBER','INTERIOR_NUMBER',
    'REFERENCE'];
    public datosChofer: Array<ItemGrid>;
    public chofer :Chofer;
    public dataChofer:any;

    // Modal messages
    private readonly CONFIRM_DELETE_MSG = '¿Está seguro dar de baja al chofer?';

    constructor(private _generalService: generalService, 
        public dataService: DataService, 
        public dialog: MatDialog,
        public _activated : ActivatedRoute) {
          this.chofer = new Chofer();
          this.dataChofer = new Array();
    }

    ngOnInit() {
        this.consultarChofres();
    }
    consultarChofres(){
        //let chofer = new Chofer();
        let metodo = 'Driver/consultarChoferes';
       
        const params = { 
          loacs: sessionStorage.getItem('acslo')  
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
          result => {
            this.datosChofer = JSON.parse(result);
        
            this.dataSource = new DataSourceGrid(this.datosChofer, this.paginator, this.sort);
            
            
            },
          error => {  console.log(<any>error);  }
        );
    }
    searchFilter(searchTerm: string) {
        if(this.datosChofer.length <= 0) {
          this.dataSource = undefined;
        } else {
          let filtroVehiculos = this.datosChofer;
          if(searchTerm != "") {
            filtroVehiculos = this.datosChofer.filter((obj: any) => {            
              if (obj.NAME.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
              //|| obj.POLIZA_RC && obj.POLIZA_RC.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
              )
                  return true;
              else
                  return false;
            });
          }
          this.dataSource = new DataSourceGrid(filtroVehiculos, this.paginator, this.sort);
        }
    }
    confirmDeleteDriver(chofer: ItemGrid) {
        this.dataService.modal = 'confirm';
        this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
      
        const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
        this.dataService.dialogRef = dialogModal;

        this.dataChofer = chofer;
      
        dialogModal.afterClosed().subscribe(result => {
          if (this.dataService.guardado) {
            this.deleterow(this.dataChofer);
          }
        });
    }
    deleterow(chofer: any) {
        const params = { 
          loacs: sessionStorage.getItem('acslo'),
          idchofer:chofer.DRIVER_ID
        };
        this._generalService.metodoCallParams(params, `Driver/deleteDriver`)
        .subscribe(ok => {
            
            this.consultarChofres();
            
            setTimeout(() => {
                this._generalService.toastCall("El registro se dio de baja exitosamente");
              }, 500); 

        }, error => {
          // Custom error handler
        }); 
    }

}


// WEBPACK FOOTER //
// ./src/app/chofer/consultar-eliminar/choferes-consultar.component.ts